// extracted by mini-css-extract-plugin
export default {"content":"BasicReports__content___dqYMa","reportsList":"BasicReports__reportsList___pwl4A","title":"BasicReports__title___aXuCG"};